import type { IEmptyCustomFieldTableColumn } from 'volta/models/types/custom-field-definition';

export default function checkTableColumns() {
  return (_: string, columns: IEmptyCustomFieldTableColumn[]) => {
    const checks: number[] = [];

    if (columns?.length) {
      columns.forEach((c: IEmptyCustomFieldTableColumn, index: number) => {
        if (!c.name || !c.fieldType) {
          checks.push(index);
        } else if (c.fieldType === 'FORMULA' && !c.formula) {
          checks.push(index);
        }
      });
    }

    return checks.length === 0 || checks;
  };
}
